/* eslint-disable import/no-named-as-default-member */
import { effect } from '@preact/signals-react'

import { encryptData } from '@/helpers'
import offlineDB from '@/indexeddb'
import { type TConvocatoria } from '@/interfaces'

import convocatoriasRequests from './requests'
import { setDefaultCity } from './utils'

import { ConvocatoriasState } from '.'

effect(setDefaultCity)

export const convocatoriasStateActions = {
  getUserConvocatorias: async () => {
    let convocatoriasList: TConvocatoria[] = []

    const convocatoriasData = await convocatoriasRequests.getUserConvocatorias()
    convocatoriasList = convocatoriasData.data ?? convocatoriasList

    await convocatoriasStateActions.setConvocatorias(convocatoriasList)
  },
  setConvocatorias: async (convocatoriasData: TConvocatoria[]) => {
    if (convocatoriasData.length === 1) {
      ConvocatoriasState.currentConvocatoria.value = convocatoriasData[0]
    }

    const convocatoriasDataEncrypted = encryptData(
      JSON.stringify(convocatoriasData)
    )

    await offlineDB.saveMultipleToStore(offlineDB.stores.USER_STORE, [
      {
        data: convocatoriasDataEncrypted,
        id: offlineDB.userStoreIds.convocatorias,
      },
    ])

    ConvocatoriasState.convocatorias.value = [...convocatoriasData]
  },
  setCurrentCity: (city: string | undefined) => {
    ConvocatoriasState.currentCity.value = city ?? null
  },
  setCurrentConvocatoria: (convocatoriaId: number | string) => {
    const currentConvocatoria = ConvocatoriasState.convocatorias
      .peek()
      .find((item) => item.id === convocatoriaId)

    ConvocatoriasState.currentConvocatoria.value = currentConvocatoria ?? {}
  },
}
